/** Each column's max width is `MAX × (usableWidth / numCols)`. */
export const EVEN_SHARE_RATIO = {
	MAX: 2,
} as const;
